<template>
  <span class="separator">|</span>
</template>

<script>
export default {
  name: "Separator"
}
</script>

<style scoped>
.separator {
  color: #efa118;
  opacity: 0.75;
  font-size: 4vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Separator.vue